/* NoraVesa — canlı (predictive) arama. Shopify'ın /search/suggest.json uç noktasını kullanır. */
(function () {
  "use strict";

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      var ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function render(results, container) {
    if (!results || !results.length) {
      container.innerHTML = '<p class="predictive-search__empty">' + (window.NoraVesaStrings && window.NoraVesaStrings.noResults || 'Sonuç bulunamadı.') + '</p>';
      return;
    }
    var html = '<ul class="predictive-search__list">';
    results.forEach(function (p) {
      var price = p.price ? (p.price / 100).toLocaleString('tr-TR', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'TRY' }) : '';
      html += '' +
        '<li>' +
          '<a href="' + p.url + '" class="predictive-search__item">' +
            '<span class="ratio-box predictive-search__img"><img src="' + (p.image || '') + '&width=100" alt="" loading="lazy"></span>' +
            '<span class="predictive-search__info"><span class="predictive-search__title">' + p.title + '</span><span class="predictive-search__price">' + price + '</span></span>' +
          '</a>' +
        '</li>';
    });
    html += '</ul>';
    container.innerHTML = html;
  }

  function search(term, container) {
    if (!term) { container.innerHTML = ''; return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products.map(function (p) {
          return { title: p.title, url: p.url, image: p.featured_image ? p.featured_image.url : (p.image || ''), price: p.price };
        }), container);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var input = document.querySelector('[data-predictive-search-input]');
    var results = document.querySelector('[data-predictive-search-results]');
    if (!input || !results) return;
    var run = debounce(function () { search(input.value.trim(), results); }, 220);
    input.addEventListener('input', run);
  });
})();
